import React, { Component } from "react";
import { config } from "../../contexts/UrlContext";
import axios from "axios";
import { Dropdown } from "semantic-ui-react";
import { SettingsContext } from "../../contexts/SettingsContext";
import { toast } from "react-toastify";

export default class LocationMultiSearch extends Component {

    static contextType = SettingsContext;

    constructor(props) {
        super(props); 
        this.state = {
            locationOptions: [],
            isLoading: false,
            current: null
        }
    }

    componentDidMount() {
        this.setState({ current: this.props.text, locationOptions: this.props.options });
    }

    componentWillReceiveProps(nextProps) {
        // You don't have to do this check first, but it can help prevent an unneeded render
        if (nextProps.options !== this.state.locationOptions) {
            this.setState({ locationOptions: nextProps.options });
        }
    }

    onLocationSearchChange = (e, value) => {

        if (value.searchQuery != "") {
            let ele = e.target;
            let duration = 400; // delay
            clearTimeout(this.inputTimer);
            this.inputTimer = setTimeout(async () => {
                let query = value.searchQuery;
                if (query)
                    await this.getLocations(query, ele);
            }, duration);
        }
    }

    getLocations = async (query, ele) => {
        try {
            let response;

            if (!this.props.auth || this.props.auth == null) {
                response = await axios.get(`${config.baseUrl}/api/Search/LocationSearch?query=${query}`);
            } else {
                let header = {
                    Authorization: `Bearer ${this.props.auth.user?.access_token}`,
                }
                response = await axios.get(`${config.baseUrl}/api/Search/LocationSearch?query=${query}`, { headers: header });
            }

            let locations = response.data.map(location => {
                return {
                    key: location.value,
                    text: location.name,
                    name: location.name,
                    value: location.value
                }
            });

            // re-render the result
            //Add the locations to the options 
            let options = this.state.locationOptions;

            for (let i = 0; i < locations.length; i++) {
                let found = options.find(x => x.key === locations[i].key);
                if (found === undefined) {
                    //Add in new value
                    options.unshift(locations[i]);
                }
            }

            this.setState({ locationOptions: options, isLoading: false });
        } catch (error) {
            console.log(error);
            toast.error("Error getting results");
        }
    }

    onChange = (e, data) => {
        let index = data.value.length - 1;
        if (index > 0) {
            let text = data.options.find(x => x.value == data.value[index]).text;

            this.setState({ current: text });
        }
        else {
            this.setState({ current: null });
        }
        this.props.change(data.value);
    }

    handleClick = (e) => {
        if (e.target.className == "dropdown icon") {
            this.getData("favorite", e.target.parentNode);
        }
    }

    render() {
        return (
            <div>
                <Dropdown
                    className="locationMultiSearch dropdown"
                    style={{ marginLeft: 10, backgroundColor: "#e5e5e5" }} 
                    loading={this.state.isLoading}
                    placeholder="Select Location..."
                    fluid
                    multiple
                    search
                    selection
                    text={this.state.current}
                    value={this.props.value}
                    options={this.state.locationOptions}
                    onSearchChange={this.onLocationSearchChange}
                    onChange={this.onChange}
                />
            </div>
        );
    }
}